import { FC, useEffect, useRef, useState } from "react";
import { replaceStringVariables } from "../../Helpers";

interface CountdownTimerProps {
    countdownTo: Date;
    allowNegative?: boolean;
    timePassedText?: string;
    countdownStrings?: CountdownStrings;
    onExpiry?: () => void;
}

interface CountdownStrings {
    day: string;
    days: string;
    hour: string;
    hours: string;
    minute: string;
    minutes: string;
    second: string;
    seconds: string;
}

const defaultCountdownStrings: CountdownStrings = {
    day: "{1} day",
    days: "{1} days",
    hour: "{1} hour",
    hours: "{1} hours",
    minute: "{1} minute",
    minutes: "{1} minutes",
    second: "{1} second",
    seconds: "{1} seconds"
};

function formatTimeDiff(diffMs: number, countdownStrings: CountdownStrings): string {
    const absMs = Math.abs(diffMs);
    const seconds = Math.floor(absMs / 1000) % 60;
    const minutes = Math.floor(absMs / (1000 * 60)) % 60;
    const hours = Math.floor(absMs / (1000 * 60 * 60)) % 24;
    const days = Math.floor(absMs / (1000 * 60 * 60 * 24));

    if (days > 0) return replaceStringVariables(days === 1 ? countdownStrings.day : countdownStrings.days, { 1: days });
    if (hours > 0) return replaceStringVariables(hours === 1 ? countdownStrings.hour : countdownStrings.hours, { 1: hours });
    if (minutes > 0) return replaceStringVariables(minutes === 1 ? countdownStrings.minute : countdownStrings.minutes, { 1: minutes });
    return replaceStringVariables(seconds === 1 ? countdownStrings.second : countdownStrings.seconds, { 1: seconds }); ;
}

export const CountdownTimer: FC<CountdownTimerProps> = ({ countdownTo, allowNegative = false, timePassedText, countdownStrings = defaultCountdownStrings, onExpiry }) => {
    const [now, setNow] = useState<Date>(new Date());
    const hasExpiredRef = useRef(false);

    useEffect(() => {
        const timer = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    const diffMs = countdownTo.getTime() - now.getTime();

    useEffect(() => {
        if (diffMs <= 0 && !hasExpiredRef.current) {
            hasExpiredRef.current = true;
            onExpiry?.();
        }
        else if (diffMs > 0) {
            hasExpiredRef.current = false;
        }
    }, [diffMs, onExpiry]);

    if (diffMs < 0 && !allowNegative) {
        if (!timePassedText) return null;

        return <span>{timePassedText}</span>;
    }

    return <span>{formatTimeDiff(diffMs, countdownStrings)}</span>;
};